export default class Header {
  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.menu = el.querySelector('.header--menu')
    this.hoverVisual = el.querySelector('.header--menu-hover-visual')
    this.menuLinks = el.querySelectorAll('.header--menu-list a')
    this.init()
  }

  init() {
    if (!this.hamburger) return
    this.hamburger.addEventListener('click', () => {
      this.isMenuOpen() ? this.closeMenu() : this.openMenu()
    })
    this.initMenuHover()
  }

  initMenuHover() {
    if (!this.hoverVisual || !this.menuLinks.length || window.innerWidth < 992) return

    const offset = 128

    this.menuLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const rect = link.getBoundingClientRect()
        this.hoverVisual.style.left = `${rect.right + offset}px`
        this.hoverVisual.style.top = `${rect.top + rect.height / 2}px`
        this.hoverVisual.classList.add('is-visible')
      })
      link.addEventListener('mouseleave', () => this.hoverVisual.classList.remove('is-visible'))
    })
  }

  isMenuOpen() {
    return this.menu?.classList.contains('is-full')
  }

  openMenu() {
    this.menu?.classList.add('is-full')
    this.hamburger.classList.add('is-active')
    this.hamburger.setAttribute('aria-expanded', 'true')
    this.el.classList.add('is-menu-open')
  }

  closeMenu() {
    this.menu?.classList.remove('is-full')
    this.hamburger.classList.remove('is-active')
    this.hamburger.setAttribute('aria-expanded', 'false')
    this.el.classList.remove('is-menu-open')
  }
}
